export const STREAMLAIN_DISCLOSURE_INITIAL_SCALE = '0.05';
export const STREAMLAIN_DISCLOSURE_ENTER_OFFSET = '8px';
export const STREAMLAIN_DISCLOSURE_ENTER_TIMING =
  '0.32s cubic-bezier(0.2, 0.9, 0.25, 1) both';
export const STREAMLAIN_DISCLOSURE_EXIT_TIMING =
  '0.28s cubic-bezier(0.4, 0, 0.9, 0.1) both';

export const STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_KEYFRAME =
  'streamlain-disclosure-overlay-enter';
export const STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_RIGHT_KEYFRAME =
  'streamlain-disclosure-overlay-enter-right';
export const STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_LEFT_KEYFRAME =
  'streamlain-disclosure-overlay-enter-left';

export const STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_ANIMATION = `${STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_KEYFRAME} ${STREAMLAIN_DISCLOSURE_ENTER_TIMING}`;
export const STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_RIGHT_ANIMATION = `${STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_RIGHT_KEYFRAME} ${STREAMLAIN_DISCLOSURE_ENTER_TIMING}`;
export const STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_LEFT_ANIMATION = `${STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_LEFT_KEYFRAME} ${STREAMLAIN_DISCLOSURE_ENTER_TIMING}`;

interface StreamLainDisclosureKeyframeStep {
  opacity: number;
  transform: string;
}

interface StreamLainDisclosureKeyframes {
  from: StreamLainDisclosureKeyframeStep;
  to: StreamLainDisclosureKeyframeStep;
}

function enterTransform(axis: 'x' | 'y', offset: string) {
  const translate =
    axis === 'x' ? `translateX(${offset})` : `translateY(${offset})`;
  return `${translate} scale(${STREAMLAIN_DISCLOSURE_INITIAL_SCALE})`;
}

function settledTransform(axis: 'x' | 'y') {
  return `${axis === 'x' ? 'translateX(0)' : 'translateY(0)'} scale(1)`;
}

export const streamLainDisclosureOverlayEnterKeyframes: StreamLainDisclosureKeyframes =
  {
    from: {
      opacity: 0,
      transform: enterTransform('y', STREAMLAIN_DISCLOSURE_ENTER_OFFSET),
    },
    to: {
      opacity: 1,
      transform: settledTransform('y'),
    },
  };

export const streamLainDisclosureOverlayExitKeyframes: StreamLainDisclosureKeyframes =
  {
    from: {
      opacity: 1,
      transform: settledTransform('y'),
    },
    to: {
      opacity: 0,
      transform: enterTransform('y', STREAMLAIN_DISCLOSURE_ENTER_OFFSET),
    },
  };

export const streamLainDisclosureOverlayEnterRightKeyframes: StreamLainDisclosureKeyframes =
  {
    from: {
      opacity: 0,
      transform: enterTransform('x', `-${STREAMLAIN_DISCLOSURE_ENTER_OFFSET}`),
    },
    to: {
      opacity: 1,
      transform: settledTransform('x'),
    },
  };

export const streamLainDisclosureOverlayExitRightKeyframes: StreamLainDisclosureKeyframes =
  {
    from: {
      opacity: 1,
      transform: settledTransform('x'),
    },
    to: {
      opacity: 0,
      transform: enterTransform('x', `-${STREAMLAIN_DISCLOSURE_ENTER_OFFSET}`),
    },
  };

export const streamLainDisclosureOverlayEnterLeftKeyframes: StreamLainDisclosureKeyframes =
  {
    from: {
      opacity: 0,
      transform: enterTransform('x', STREAMLAIN_DISCLOSURE_ENTER_OFFSET),
    },
    to: {
      opacity: 1,
      transform: settledTransform('x'),
    },
  };

export const streamLainDisclosureOverlayExitLeftKeyframes: StreamLainDisclosureKeyframes =
  {
    from: {
      opacity: 1,
      transform: settledTransform('x'),
    },
    to: {
      opacity: 0,
      transform: enterTransform('x', STREAMLAIN_DISCLOSURE_ENTER_OFFSET),
    },
  };

function keyframesCss(name: string, keyframes: StreamLainDisclosureKeyframes) {
  return `
    @keyframes ${name} {
      from {
        opacity: ${keyframes.from.opacity};
        transform: ${keyframes.from.transform};
      }
      to {
        opacity: ${keyframes.to.opacity};
        transform: ${keyframes.to.transform};
      }
    }
  `;
}

export function streamLainDisclosureOverlayKeyframesCss(
  names: {
    enter?: string;
    enterLeft?: string;
    enterRight?: string;
    exit?: string;
    exitLeft?: string;
    exitRight?: string;
  } = {}
) {
  const {
    enter = STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_KEYFRAME,
    enterLeft = STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_LEFT_KEYFRAME,
    enterRight = STREAMLAIN_DISCLOSURE_OVERLAY_ENTER_RIGHT_KEYFRAME,
    exit,
    exitLeft,
    exitRight,
  } = names;

  return [
    keyframesCss(enter, streamLainDisclosureOverlayEnterKeyframes),
    keyframesCss(enterRight, streamLainDisclosureOverlayEnterRightKeyframes),
    keyframesCss(enterLeft, streamLainDisclosureOverlayEnterLeftKeyframes),
    exit
      ? keyframesCss(exit, streamLainDisclosureOverlayExitKeyframes)
      : undefined,
    exitRight
      ? keyframesCss(exitRight, streamLainDisclosureOverlayExitRightKeyframes)
      : undefined,
    exitLeft
      ? keyframesCss(exitLeft, streamLainDisclosureOverlayExitLeftKeyframes)
      : undefined,
  ]
    .filter(Boolean)
    .join('\n');
}
